import { useEffect, useMemo, useState } from "react";
import { AKAS_CHART_COLORS } from "../utils/constants/chartColors";

const currentTheme = () => document.documentElement.getAttribute("data-bs-theme") || "light";

/**
 * Menjaga arti warna chart tetap konsisten sekaligus mempertahankan kontras
 * ketika tema aplikasi berubah tanpa reload halaman.
 */
const useAkasChartColors = () => {
  const [theme, setTheme] = useState(currentTheme);

  useEffect(() => {
    const observer = new MutationObserver(() => setTheme(currentTheme()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-bs-theme"] });

    return () => observer.disconnect();
  }, []);

  return useMemo(
    () =>
      theme === "dark"
        ? {
            ...AKAS_CHART_COLORS,
            moneyOut: "#91a5a7",
            moneyOutSoft: "#6f878a",
            neutral: "#819497",
            grid: "#29484d",
          }
        : AKAS_CHART_COLORS,
    [theme],
  );
};

export default useAkasChartColors;

